import {regionToDistrictList} from "@/composables/list/regionToDistrict.list";
import {citiesList} from "@/composables/list/cities.list";
import type {DistrictKey} from "./getDistrictName";
import type {RegionKey} from "./getRegionName";

/**
 * Тип для объекта с регионами (ключ региона -> название региона)
 */
export type RegionsMap = Record<RegionKey, string>;

/**
 * Возвращает список регионов для указанного округа
 * @param district - Ключ округа
 * @returns Объект с ключами-кодами регионов и значениями-названиями регионов
 *
 * @example
 * // Получить все регионы Центрального федерального округа
 * const centralRegions = getRegionsByDistrict("central");
 * // Результат: {"belgorod": "Белгородская область", "bryansk": "Брянская область", ...}
 */
export function getRegionsByDistrict(district: DistrictKey): RegionsMap {
    const regions: Partial<RegionsMap> = {};

    for (const [regionKey, districtValue] of Object.entries(regionToDistrictList)) {
        if (districtValue === district) {
            const key = regionKey as RegionKey;
            regions[key] = citiesList[key];
        }
    }

    return regions as RegionsMap;
}
